/* export const ethnftmarketaddress = "0xAF3c12155C491160778c0b3Df7F1bd5cB35F7682"
export const ethnftaddress = "0x6771c0F067e5027934dE407f90DC6B4E7B653c7c" */

export const ethnftmarketaddress = "0x8735B1B63Ed3eE1440cE0A8180bb84048f4e3721";
export const ethnftaddress = "0x0591D53936c81e8149AcD08dD07f131E712caD40";